module.exports = __webpack_public_path__ + "assets/img/2.ad6a2802.png";